import { getNStatusLabel } from "@/lib/utils/recommendation";
import { NStatus } from "@/types/field";
import { Chip } from "@heroui/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

function NStatusChip({ nStatus }: { nStatus: NStatus }) {
    const { t } = useTranslation("fields-list");

    return (
        <Chip
            radius="sm"
            size="sm"
            classNames={{
                base: classNames({
                    "text-white": true,
                    "bg-red-100": nStatus === "red",
                    "bg-green-100": nStatus === "green",
                    "bg-yellow-100": nStatus === "yellow",
                }),
                content: classNames({
                    "font-bold": true,
                    "text-red-700": nStatus === "red",
                    "text-green-700": nStatus === "green",
                    "text-yellow-700": nStatus === "yellow",
                }),
            }}
        >
            {getNStatusLabel(nStatus, t)}
        </Chip>
    );
}

export default NStatusChip;
